/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CustomField } from '../models';
/**
 * CustomFieldsApi - axios parameter creator
 * @export
 */
export const CustomFieldsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * クライアントのカスタム情報を Excel 形式でエクスポートするAPI
         * @summary カスタム情報のエクスポート
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldsExport: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/custom_fields_export_excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * カスタム情報のインポートAPI
         * @summary カスタム情報のインポート
         * @param {any} file カスタム情報インポート用のxlsxファイル
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldsImport: async (file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('customFieldsImport', 'file', file)
            const localVarPath = `/api/user/custom_fields_import_excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * カスタム情報一覧取得API
         * @summary カスタム情報一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFields: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/custom_fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomFieldsApi - functional programming interface
 * @export
 */
export const CustomFieldsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomFieldsApiAxiosParamCreator(configuration)
    return {
        /**
         * クライアントのカスタム情報を Excel 形式でエクスポートするAPI
         * @summary カスタム情報のエクスポート
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customFieldsExport(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customFieldsExport(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * カスタム情報のインポートAPI
         * @summary カスタム情報のインポート
         * @param {any} file カスタム情報インポート用のxlsxファイル
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customFieldsImport(file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customFieldsImport(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * カスタム情報一覧取得API
         * @summary カスタム情報一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomFields(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomField>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomFields(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomFieldsApi - factory interface
 * @export
 */
export const CustomFieldsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomFieldsApiFp(configuration)
    return {
        /**
         * クライアントのカスタム情報を Excel 形式でエクスポートするAPI
         * @summary カスタム情報のエクスポート
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldsExport(options?: any): AxiosPromise<any> {
            return localVarFp.customFieldsExport(options).then((request) => request(axios, basePath));
        },
        /**
         * カスタム情報のインポートAPI
         * @summary カスタム情報のインポート
         * @param {any} file カスタム情報インポート用のxlsxファイル
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldsImport(file: any, options?: any): AxiosPromise<void> {
            return localVarFp.customFieldsImport(file, options).then((request) => request(axios, basePath));
        },
        /**
         * カスタム情報一覧取得API
         * @summary カスタム情報一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFields(options?: any): AxiosPromise<Array<CustomField>> {
            return localVarFp.getCustomFields(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomFieldsApi - interface
 * @export
 * @interface CustomFieldsApi
 */
export interface CustomFieldsApiInterface {
    /**
     * クライアントのカスタム情報を Excel 形式でエクスポートするAPI
     * @summary カスタム情報のエクスポート
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldsApiInterface
     */
    customFieldsExport(options?: AxiosRequestConfig): AxiosPromise<any>;

    /**
     * カスタム情報のインポートAPI
     * @summary カスタム情報のインポート
     * @param {any} file カスタム情報インポート用のxlsxファイル
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldsApiInterface
     */
    customFieldsImport(file: any, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * カスタム情報一覧取得API
     * @summary カスタム情報一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldsApiInterface
     */
    getCustomFields(options?: AxiosRequestConfig): AxiosPromise<Array<CustomField>>;

}

/**
 * Request parameters for customFieldsImport operation in CustomFieldsApi.
 * @export
 * @interface CustomFieldsApiCustomFieldsImportRequest
 */
export interface CustomFieldsApiCustomFieldsImportRequest {
    /**
     * カスタム情報インポート用のxlsxファイル
     * @type {any}
     * @memberof CustomFieldsApiCustomFieldsImport
     */
    readonly file: any
}

/**
 * CustomFieldsApi - object-oriented interface
 * @export
 * @class CustomFieldsApi
 * @extends {BaseAPI}
 */
export class CustomFieldsApi extends BaseAPI implements CustomFieldsApiInterface {
    /**
     * クライアントのカスタム情報を Excel 形式でエクスポートするAPI
     * @summary カスタム情報のエクスポート
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldsApi
     */
    public customFieldsExport(options?: AxiosRequestConfig) {
        return CustomFieldsApiFp(this.configuration).customFieldsExport(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * カスタム情報のインポートAPI
     * @summary カスタム情報のインポート
     * @param {CustomFieldsApiCustomFieldsImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldsApi
     */
    public customFieldsImport(requestParameters: CustomFieldsApiCustomFieldsImportRequest, options?: AxiosRequestConfig) {
        return CustomFieldsApiFp(this.configuration).customFieldsImport(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * カスタム情報一覧取得API
     * @summary カスタム情報一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldsApi
     */
    public getCustomFields(options?: AxiosRequestConfig) {
        return CustomFieldsApiFp(this.configuration).getCustomFields(options).then((request) => request(this.axios, this.basePath));
    }
}
